import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from 'antd'
import { faSearch } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHistory } from 'react-router'
import classNames from 'classnames'
import { useIsMobile } from 'hooks/useIsMobile'
import { EmptyStateSection } from 'components/ui/empty-states/empty-state-section'
import styles from './Library.module.scss'
import { Folders } from './components/Folders'
import { Populars } from './components/Populars'
import { CategoriesSelect } from './components/CategoriesSelect'

export const Library = () => {
  const { t } = useTranslation()
  const [search, setSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')
  const history = useHistory()
  const isMobile = useIsMobile()

  const [isLoadingPopulars, setIsLoadingPopulars] = useState(true)
  const [isLoadingFolders, setIsLoadingFolders] = useState(true)
  const [sectionHasCourses, setSectionHasCourses] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search)
    }, 1000)
    return () => clearTimeout(timer)
  }, [search])

  const handleSelectCategory = (selected: any) => {
    if (!selected.path) return
    history.push(selected.path)
  }

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>{t('availableCourses.title')}</div>
      </div>
      <div className={styles.optionsContainer}>
        <div
          className={classNames(
            styles.searchContainer,
            isMobile ? styles.searchContainerMobile : ''
          )}
        >
          <CategoriesSelect onSelect={handleSelectCategory} />
          <Input
            placeholder={t('home.lmsIndex.search.placeholder')}
            className={styles.search}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            suffix={<FontAwesomeIcon icon={faSearch} />}
          />
        </div>
      </div>
      <div
        className={classNames(
          styles.categoriesContainer,
          isMobile && styles.categoriesContainerMobile
        )}
      >
        {!isLoadingFolders && !isLoadingPopulars && !sectionHasCourses && (
          <EmptyStateSection
            text={t('availableCourses.emptyStates.section.text')}
          />
        )}
        <Populars
          search={debouncedSearch}
          setIsLoading={setIsLoadingPopulars}
          setHasCourses={setSectionHasCourses}
        />
        <Folders
          search={debouncedSearch}
          setIsLoading={setIsLoadingFolders}
          setHasCourses={setSectionHasCourses}
        />
      </div>
    </div>
  )
}
